import { HStack, VStack, Button, MenuButton, Menu, MenuList } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '300px',
};

export function DealMap({ latitude, longitude }: { latitude: string; longitude: string }) {
  const { colors } = useTheme();

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyB5tXrkiapXmzmvkkW0-7MQvfx1LL9VScQ',
  });

  const listOfDirections = [
    {
      name: 'À pé',
      icon: 'fas fa-walking',
      url: `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=walking`,
    },
    {
      name: 'De carro',
      icon: 'fas fa-car',
      url: `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=driving`,
    },
    {
      name: 'De bicicleta',
      icon: 'fas fa-bicycle',
      url: `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=bicycling`,
    },
    {
      name: 'De transporte público',
      icon: 'fas fa-bus',
      url: `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=transit`,
    },
  ];

  return (
    <VStack width={'100%'} alignItems={'flex-start'} marginTop="20px">
      <HStack width={'100%'} spacing={0} justifyContent={'space-between'}>
        <Text  fontFamily={'Glory'} fontWeight={'bold'} fontSize={18}>
          Como chegar
        </Text>
        <Menu>
          <MenuButton fontSize={'14px'} fontWeight={'600'} borderWidth={1} borderRadius={8} padding="5px 12px" borderColor={colors.primaryColor} color={colors.primaryColor}>
            IR AGORA
          </MenuButton>
          <MenuList zIndex={10} width={'100px'} alignItems={'flex-start'} flexDirection={'column'} >
            {listOfDirections.map((direction) => (
              <Button
                key={direction.name}
                variant="link"
                padding={'10px 20px'}
                colorScheme="primary"
                onClick={() => window.open(direction.url)}
              >
                <i className={direction.icon} style={{ marginRight: 8, color: colors.primaryColor }} />
                {direction.name}
              </Button>
            ))}
          </MenuList>
        </Menu>
      </HStack>
      <Text color="#747474" fontFamily={'Glory'} fontWeight={500} fontSize={14}>
        Arraste o bonequinho amarelo para ir até o endereço ou clique no alvo para obter direções.
      </Text>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
          }}
          zoom={17}
        >
          <Marker
            position={{
              lat: parseFloat(latitude),
              lng: parseFloat(longitude),
            }}
          />
        </GoogleMap>
      )}
    </VStack>
  );
}
